module.exports = __webpack_public_path__ + "img/腾讯云.1eab8421.png";